import React from "react";

// Company name component to share across pages
const companyDetails = {
  name: "GoFood LLC",
};

const CompanyNameHeader = () => {
  return (
    <h1 className="text-2xl font-extrabold text-gray-900 mb-6 leading-snug">
      <span className="text-blue-700">{companyDetails.name}</span>
      <span className="text-gray-700"> | Business Valuation Report</span>
    </h1>
  );
};

export default CompanyNameHeader;
